import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { FormControl, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import { bankActions, getBankById, updateBank } from "../../../../redux/reducer/bank/bankReducer";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminBankEdit({ open, handleClose, id, clear }) {
  // Local State
  const [formData, setFormData] = useState({
    bankName: "",
  });
  const [fetch, setFetch] = useState(true);

  // Redux State
  const dispatch = useDispatch();
  const data = useSelector((state) => state.bank.data.docs);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (fetch) {
      let x = data.findIndex((item) => item._id === id);
      if (x > -1) {
          setFormData({
              bankName : data[x].bankName ? data[x].bankName : ""
          })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan mohon refresh halaman / kontak developer anda",
        });
      }
      setFetch(false)
    }
  }, [fetch]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      token: token,
      value: formData,
      id: id
    };
    Swal.fire({
      title: `Periksa kembali data yang akan edit`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        dispatch(updateBank(data)).then((res) => {
            if (res.payload.status === 200) {
              const getDataById = {
                token: token,
                id: res.payload.data._id,
              };
              dispatch(getBankById(getDataById)).then((res) => {
                dispatch(bankActions.editBank(res.payload.data));
                handleCloseModal();
                toast.success(res.payload.message);
              });
            } else {
              toast.error(res.payload.message);
              handleCloseModal();
            }
          });
      } else {
        setFormData({
          bankName: "",
        });
      }
    });
  };

  const handleCloseModal = () => {
    clear();
    handleClose();
  }

  return (
    <>
      <ToastContainer />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"EDIT DATA BANK"}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent style={{ padding: "5px 24px" }}>
            <FormControl>
              <TextField
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ maxLength: 20 }}
                size="small"
                error={false}
                label="NAMA BANK"
                value={formData.bankName}
                name="bankName"
                fullWidth
                variant="standard"
                style={{ width: "90vw", maxWidth: "400px" }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal} color="error">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

AdminBankEdit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  clear: PropTypes.func,
  id: PropTypes.string
};
